<template>
  <div
    style="position:relative;height:100%;"
  >
    <div
        style="padding: 25px;text-align:left;z-index:4;border-bottom: 1px solid rgba(0,0,0,0.1);background:white;padding-top: var(--mobile-padding-top, 25px);"
    >
        <h1>
            Files
        </h1>
        <span style="font-weight: normal;">Files uploaded to your account</span>
        <v-btn
            v-if="getDomainInfo && getDomainInfo.info && getDomainInfo.info.files && $vuetify.breakpoint.smAndDown"
            fab
            color="primary"
            @click="infoDialog = true"
            style="position:absolute;right:20px;top: 20px;"
        >
            <v-icon>
                mdi-help
            </v-icon>
        </v-btn>
    </div>
    <div
        class="standard-content"
        :class="{ 'mobile-content': $vuetify.breakpoint.xs}"
        style="padding: 25px;position:relative;"
    >
        <div
            style="text-align:right;"
        >
            <v-btn
                @click="clickFileUpload()"
            >
                <v-icon
                    left
                >
                    mdi-upload
                </v-icon>
                Upload File(s)
            </v-btn>
            <input
                type="file"
                ref="files"
                multiple
                v-on:change="handleFileUploads()"
                style="display: none;"
            />
        </div>
        <v-layout
            row
            wrap
            class="d-flex"
        >
            <v-flex
                class="order-md-first order-sm-last"
                sm12
                :md9="!expandedPreview"
                :md6="expandedPreview"
            >
                <v-data-table
                    v-if="!$vuetify.breakpoint.xs"
                    select-all
                    v-model="selected"
                    :headers="headers"
                    :items="files"
                    item-key="id"
                    class="elevation-1"
                    :rows-per-page-items="[15,30]"
                >
                    <template
                        v-slot:items="props"
                    >
                        <tr
                            @click="props.selected = !props.selected"
                        >
                            <td>
                                <v-checkbox
                                    v-model="props.selected"
                                    primary
                                    hide-details
                                    @click.stop="props.selected = !props.selected"
                                />
                            </td>
                            <td>{{ props.item.name }}</td>
                            <td>
                                {{ convertToLocal(props.item.created_at) }}
                            </td>
                            <td>
                                <span v-html="isContactUploaded(props.item) ? 'You' : '<span class=\'legalFoot\'></span>'"></span>
                            </td>
                            <td>
                                <v-btn
                                    v-if="props.item.read == false && isContactUploaded(props.item)"
                                    fab
                                    small
                                    flat
                                    @click="deleteFile(props.item)"
                                >
                                    <v-icon>
                                        mdi-delete
                                    </v-icon>
                                </v-btn>
                                <v-btn
                                    fab
                                    small
                                    flat
                                    color="primary"
                                    @click.stop="getFile(props.item.id, props.item.name)"
                                >
                                    <v-icon>
                                        mdi-download
                                    </v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <v-data-table
                    v-else
                    :headers="mobileHeaders"
                    :items="files"
                    item-key="id"
                    class="elevation-1"
                    :rows-per-page-items="[15,30]"
                >
                    <template
                        v-slot:items="props"
                    >
                        <tr
                            @click.self="props.selected = !props.selected"
                        >
                            <td>
                                {{ props.item.name }}
                                <br />
                                <small>
                                    {{ convertToLocal(props.item.created_at) }}
                                    by
                                    <span v-html="isContactUploaded(props.item) ? 'You' : '<span class=\'legalFoot\'></span>'"></span>
                                </small>
                            </td>
                            <td>
                                <v-btn
                                    v-if="props.item.read == false && isContactUploaded(props.item)"
                                    fab
                                    small
                                    flat
                                    @click="deleteFile(props.item)"
                                >
                                    <v-icon>
                                        mdi-delete
                                    </v-icon>
                                </v-btn>
                                <v-btn
                                    fab
                                    small
                                    flat
                                    color="primary"
                                    @click="getFile(props.item.id, props.item.name)"
                                >
                                    <v-icon>
                                        mdi-download
                                    </v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
            <v-flex
                v-if="selected.length > 0 && !$vuetify.breakpoint.xs"
                :md3="!expandedPreview"
                :md6="expandedPreview"
                sm12
                style="padding-left: 15px;"
                class="order-sm-first order-md-last"
            >
                <v-card>
                    <v-toolbar
                        flat
                    >
                        File Preview
                        <v-spacer />
                        <v-btn
                            flat
                            small
                            @click="expandedPreview = !expandedPreview"
                        >
                            {{ expandedPreview ? 'Collapse Preview' : 'Expand Preview' }}
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div
                            v-if="selected.length == 1"
                        >
                            <div
                                v-if="loadingPreviews"
                            >
                                <div
                                    style="position: relative;margin: auto;width: 100%;height: 300px;background: rgba(0,0,0,0.1);border: 1px solid rgba(0,0,0,0.2);margin-top: 10px;margin-bottom: 10px;"
                                >
                                    <span
                                        style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);text-align:center;"
                                    >
                                        <v-progress-circular
                                            indeterminate
                                            color="primary"
                                            style="margin:auto;"
                                        /><br /><br />
                                        Loading Preview
                                    </span>
                                </div>
                            </div>
                            <div
                                v-else-if="getFileType(selected[0]) == 'unknown' && !loadingPreviews"
                            >
                                <div
                                    style="position: relative;margin: auto;width: 100%;height: 300px;background: rgba(0,0,0,0.1);border: 1px solid rgba(0,0,0,0.2);margin-top: 10px;margin-bottom: 10px;"
                                >
                                    <span
                                        style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);text-align:center;"
                                    >
                                        No Preview Available
                                    </span>
                                </div>
                            </div>
                            <div
                                v-else
                                style="max-width: 100%;max-height: 80%;border: 1px solid rgba(0,0,0,0.2);margin-top: 10px; margin-bottom: 10px;"
                            >
                                <div
                                    v-if="getFileType(selected[0]) == 'image'"
                                >
                                    <div>
                                        <img :src="`data:image/png;base64,${selected[0].b64}`" style="max-width: 100%;width: 100%;max-height:100%;height:100%;"/>
                                    </div>
                                </div>
                                <div
                                    v-if="getFileType(selected[0]) == 'pdf'"
                                >
                                    <div>
                                        <iframe
                                            :src="`data:application/pdf;base64,${selected[0].b64}`"
                                            style="width: 100%;height:100%;min-height: 60vh;"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <span style="font-weight: bold">File Name:</span>&nbsp;{{selected[0].name}}<br />
                                <span style="font-weight: bold">Uploaded By:</span>&nbsp;<span v-html="isContactUploaded(selected[0]) ? 'You' : '<span class=\'legalFoot\'></span>'"></span><br />
                                <span style="font-weight: bold">Upload Date/Time:</span>&nbsp;{{convertToLocal(selected[0].created_at)}}<br />
                            </div>
                        </div>
                        <div
                            v-if="selected.length > 1"
                        >
                            <div
                                style="position: relative;margin: auto;width: 100%;height: 300px;background: rgba(0,0,0,0.1);border: 1px solid rgba(0,0,0,0.2);margin-top: 10px;margin-bottom: 10px;"
                            >
                                <span
                                    style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);text-align:center;"
                                >
                                    {{selected.length}} Files Selected
                                </span>
                            </div>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            v-if="selected.length == 1 && selected[0].read == false && isContactUploaded(selected[0])"
                            color="error"
                            outline
                            @click="deleteFile(selected[0])"
                        >
                            Delete
                        </v-btn>
                        <v-spacer />
                        <v-btn
                            color="primary"
                            @click="downloadSelected()"
                        >
                            Download
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex
                v-if="selected.length == 0 && !$vuetify.breakpoint.xs"
                :md3="!expandedPreview"
                :md6="expandedPreview"
                sm12
                style="padding-left: 15px;"
                class="order-sm-first order-md-last"
            >
                <v-card>
                    <v-card-text
                        style="margin: auto;text-align:center;padding-top: 15%;padding-bottom: 15%;"
                    >
                        <v-icon
                            size="64"
                        >
                            mdi-file-hidden
                        </v-icon><br />
                        <b>No Files Selected</b><br />
                        Select a file to preview or download
                    </v-card-text>
                    <div
                        v-if="getDomainInfo  && getDomainInfo.info && getDomainInfo.info.files"
                        class="files-info"
                    >
                        <div
                            v-html="getDomainInfo.info.files"
                        />
                    </div>
                </v-card>
            </v-flex>
            <v-expand-transition>
                <v-flex
                    v-if="selected.length > 0 && $vuetify.breakpoint.xs"
                    sm12
                >
                        <v-card>
                            <v-card-text
                                style="margin: auto;text-align:center;padding-top: 15%;padding-bottom: 15%;"
                            >
                                <b>{{selected.length}} Files Selected</b><br />
                                Select a file to preview or download
                            </v-card-text>
                        </v-card>
                </v-flex>
            </v-expand-transition>
        </v-layout>
    </div>
    <v-dialog
        v-model="confirmFileUploadDialog"
        persistent
        :width="$vuetify.breakpoint.xs ? 350 : 700"
        scrollable
    >
        <v-card>
            <div
                style="padding: 25px;text-align:center;"
            >
                <v-icon
                    size="96"
                    :color="uploading ? 'primary' : ''"
                >
                    {{ uploading ? 'mdi-briefcase-upload' : 'mdi-briefcase-upload-outline' }}
                </v-icon>
                <br />
                <br />
                <h4>
                    Upload{{uploading ? 'ing' : ''}} {{uploadFiles ? uploadFiles.length : 0}} file(s) to {{ app_name }}
                </h4>
            </div>
            <v-card-text
                style="max-height: 80vh;overflow-y: scroll;"
            >
                <v-layout
                    row wrap
                >
                    <v-flex
                        v-for="file in uploadFiles"
                        :key="file.name"
                        sm6
                        xs12
                        style="padding: 5px;"
                    >
                        <v-card>
                            <div
                                style="padding: 10px;background: rgba(0,0,0,0.1);"
                            >
                                {{file.name}}
                            </div>
                            <v-img
                                v-if="getFileType(file) == 'image'"
                                :src="file.url"
                                aspect-ratio="2.75"
                            ></v-img>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn
                                    small
                                    flat
                                    :disabled="uploading"
                                    color="error"
                                    @click="popFile(file)"
                                >
                                    Delete
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-expand-transition>
                <v-progress-linear
                    v-if="uploadStatus > 0"
                    v-model="uploadStatus"
                    :indeterminate="uploadStatus == 100"
                    color="blue-grey"
                    style="padding: 0;margin:0;"
                />
            </v-expand-transition>
            <v-card-actions>
                <v-btn
                    @click="confirmFileUploadDialog = false;uploadObject = null"
                    flat
                    color="error"
                    :disabled="uploading"
                >
                    Cancel
                </v-btn>
                <v-spacer />
                <v-btn
                    @click="submitFiles()"
                    outline
                    color="primary"
                    :disabled="uploading"
                >
                    Upload
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog
        v-model="downloading"
        width="400"
    >
        <v-card>
            <v-card-text>
                Downloading {{selected.length}} files...
                <br />
                <v-progress-linear
                    indeterminate
                    query
                />
                <br />
                <v-alert
                    :value="selected.length > 1"
                    type="warning"
                >
                    You are downloading multiple files. You may be prompted by your browser to allow downloading multiple files.
                </v-alert>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      width="400"
    >
      <v-card
        style="color: white; background: #F44336;text-align:center;"
      >
        <v-card-text>
          <v-icon
            size="72"
            color="white"
          >
            mdi-delete-alert
          </v-icon>
          <h2>Are you sure?</h2>
          <p
            v-if="fileAction"
          >
            You are about to delete `{{fileAction.name}}`.<br /><b>This action is irreversable.</b>
          </p>
          <p
            v-else
          >
            You are about to delete {{selected.length}} file<span v-if="selected.length > 1">s</span>.<br /><b>This action is irreversable.</b>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            color="white"
            @click="fileAction ? deleteFile() : deleteSelected()"
          >
            I Understand, Delete
          </v-btn>
          <v-btn
            color="blue"
            dark
            @click="deleteDialog = false"
          >
            Go Back
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="infoDialog"
        width="500"
    >
        <v-card>
            <v-card-text
                v-html="getDomainInfo && getDomainInfo.info && getDomainInfo.info.files ? getDomainInfo.info.files : ''"
                style="max-height: 50vh;overflow-y: auto"
            />
            <v-card-actions
                style="background: #E0E0E0;"
            >
                <v-spacer />
                <v-btn
                    @click="infoDialog = false"
                >
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3

export default {
    name: 'Files',
    data () {
        return {
            files: [],
            uploadFiles: [],
            infoDialog: false,
            selected: [],
            deleteDialog: false,
            fileAction: {},
            expandedPreview: false,
            loadingPreviews: false,
            confirmFileUploadDialog: false,
            uploading: false,
            downloading: false,
            currentFileProgress: 0,
            downloaded: 0,
            headers: [
                {
                    text: 'File Name',
                    align: 'left',
                    sortable: true,
                    value: 'name'
                },
                {
                    text: 'Date/Time',
                    align: 'left',
                    value: 'created_at',
                    sortable: true
                },
                {
                    text: 'Uploaded By',
                    align: 'left',
                    value: 'uploaded_by',
                    sortable: false
                },
                {
                    text: 'Actions',
                    align: 'left',
                    sortable: false
                }
            ],
            mobileHeaders: [
                {
                    text: 'File Details',
                    align: 'left',
                    sortable: true,
                    value: 'name'
                },
                {
                    text: 'Actions',
                    align: 'left',
                    sortable: false
                }
            ],
        }
    },
    created () {
        this.fetchFiles()
    },
    computed: {
        ...mapGetters('userform', [
            'uploadStatus',
            'uploadState'
        ]),
        isInitial() {
            return this.uploadState === STATUS_INITIAL
        },
        isSaving() {
            return this.uploadState === STATUS_SAVING
        },
        isSuccess() {
            return this.uploadState === STATUS_SUCCESS
        },
        isFailed() {
            return this.uploadState === STATUS_FAILED
        }
    },
    watch: {
        selected () {
            if (this.selected.length > 0 && !this.downloading) {
                this.selected.forEach((file) => {
                    if (!file.blob && this.getFileType(file) !== 'unknown') {
                        this.loadingPreviews = true
                        api.userform.contactFiles.download(file.id)
                            .then(response => {
                                var base64 = btoa(
                                    new Uint8Array(response.data)
                                        .reduce((data, byte) => data + String.fromCharCode(byte), '')
                                )
                                file.b64 = base64
                                file.blob = response.data
                                this.loadingPreviews = false
                        })
                    }
                })
            } else if (this.downloading) {
                if (this.selected.length == 0) {
                    this.downloading = false
                }
            }
        },
        uploadFiles () {
            if (this.uploadFiles.length == 0)
                this.confirmFileUploadDialog = false
        }
    },
    methods: {
        ...mapMutations('userform', [
            'setFileUpload',
            'setUploadState'
        ]),
        ...mapActions('userform', [
            'uploadClientFiles'
        ]),
        fetchFiles () {
            this.loading = true
            api.userform.contactFiles.getFiles()
                .then(response => {
                    this.files = response
                })
                .catch(error => {
                    this.loading = false
                })
        },
        handleFileUploads () {
            this.setUploadState(STATUS_INITIAL)
            this.uploadFiles = Array.from(this.$refs.files.files)
            this.uploadFiles.forEach((file) => {
                file.url = URL.createObjectURL(file)
            })
            this.confirmFileUploadDialog = true
        },
        clickFileUpload () {
            this.$refs.files.click()
        },
        isContactUploaded (file) {
            return file.created_by_name.startsWith('[Contact]')
        },
        getExtension (file) {
            return file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2)
        },
        getFile (id, name) {
            this.downloading = true
            api.userform.contactFiles.download(id)
            .then(response => {
                let blob = new Blob([response.data])
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = name
                link.click()
                this.downloading = false
            })
        },
        getFileType(file) {
            switch (this.getExtension(file).toLowerCase()) {
                case "png":
                case "jpg":
                case "jpeg":
                case "gif":
                case "bmp":
                    return "image"
                case "pdf":
                    return "pdf"
                default:
                    return "unknown"
            }
        },
        downloadSelected() {
            this.downloading = true
            this.selected.forEach((file, index, array) => {
                if (file.blob) {
                    let blob = new Blob([file.blob])
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = file.name
                    link.click()
                    this.downloaded++

                    if (this.downloaded == array.length) {
                        this.downloading = false
                        this.selected = []
                        this.downloaded = 0
                    }
                } else {
                    api.userform.contactFiles.download(file.id)
                        .then((response) => {
                            let blob = new Blob([response.data])
                            let link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = file.name
                            link.click()
                            this.downloaded++
                            if (this.downloaded == array.length) {
                                this.downloading = false
                                this.selected = []
                                this.downloaded = 0
                            }
                        })
                }
            })
        },
        async saveBlob(file) {
            api.userform.contactFiles.download(file.id)
                .then(response => {
                    let b64 = btoa(String.fromCharCode(...new Uint8Array(response.data)))
                    file.b64 = b64
                    file.blob = response.data
                    return true
            })
        },
        popFile(file) {
            this.uploadFiles.splice(this.uploadFiles.indexOf(file), 1)
        },
        deleteFile(file) {
            if (file) {
                this.fileAction = file
                this.deleteDialog = true
            } else {
                if (this.fileAction) {
                    this.loading = true
                    api.userform.contactFiles.deleteFile(this.fileAction.id)
                        .then(() => {
                            this.fetchFiles()
                        })
                        .finally(() => {
                            this.loading = false
                            this.deleteDialog = false
                        })
                }
            }
        },
        submitFiles () {
            this.setUploadState(STATUS_SAVING)
            this.uploading = true
            let formData = new FormData()
            this.uploadFiles.forEach((file) => {
                formData.append(`upload`, file)
            })
            this.setFileUpload(formData)
            this.uploadClientFiles()
                .then(response => {
                    this.setUploadState(STATUS_SUCCESS)
                })
                .catch(error => {
                    this.setUploadState(STATUS_FAILED)
                })
                .finally(() => {
                    this.uploadFiles = []
                    this.uploading = false
                    this.confirmFileUploadDialog = false
                    this.fetchFiles()
                })
        },
    }
}
</script>

<style scoped>
    .standard-content {
        max-height: calc(100vh - 93px);
        height:100%;
        overflow-y:auto;
    }
    .mobile-content {
        max-height: calc(100vh - 93px - 56px - var(--mobile-padding-top) - var(--mobile-padding-bottom)) !important;
    }

    .files-info {
        margin: 20px;
        height: auto;
        overflow-y: auto;
    }
</style>